import { type FC, memo, useCallback, useEffect, useRef } from "react";
import { isEqual } from "lodash-es";
import type { ChipVariant } from "@viagogo/core/ui";
import type { Dates } from "src/types/shared/cookies";
import { dateButton } from "src/website-apps/responsive/stubhub-performer/components/calendar/mobile/mobile-calendar-filter-row/styles";
import { DateSelector } from "src/website-apps/shared/components/date-selector/DateSelector";

interface Props {
  addActiveState?: boolean;
  chipVariant?: ChipVariant;
  dates?: Dates | undefined;
  disabled?: boolean;
  hideIcon?: boolean;
  labelOverride?: string | undefined;
  onDatesChange: (val: Dates) => void;
}

export const MobileCalendarDateSelector: FC<Props> = memo(
  ({
    dates,
    onDatesChange,
    disabled = false,
    labelOverride,
    chipVariant = "ghost",
    hideIcon = true,
    addActiveState = false,
  }) => {
    const doneRendering = useRef(false);

    useEffect(() => {
      doneRendering.current = true;
      return () => {
        doneRendering.current = false;
      };
    });

    const onDatesChangeInSelector = useCallback(
      (newDates: Dates | undefined) => {
        if (!doneRendering.current) return;
        if (isEqual(newDates, dates)) return;
        if (newDates) {
          onDatesChange(newDates);
        }
      },
      [onDatesChange, dates],
    );

    return (
      <div className={dateButton}>
        <DateSelector
          addActiveState={addActiveState}
          chipKind="neutral"
          chipVariant={chipVariant}
          dates={dates ?? undefined}
          disabled={disabled}
          labelOverride={labelOverride}
          onDatesChange={onDatesChangeInSelector}
          {...(hideIcon ? { hideIcon: true } : {})}
        />
      </div>
    );
  },
);
MobileCalendarDateSelector.displayName = "MobileCalendarDateSelector";
